import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Chip from 'components/Chip';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const CollectionFilterOverviewActiveFilterItem = ({ option, onClick }) => {
  const type = get(option, 'filterIdentifier');
  const name = get(option, 'option');
  const label = get(option, 'label');
  const localizedName =
    label || I18n.localize(`productAttributes.${type}.options.${name}.shortLabel`);
  const ariaLabel =
    label ||
    I18n.localize('collectionPage.filterActions.clearFilter', {
      value: localizedName,
    });
  const handleClear = () => onClick(option);

  return (
    <div className="CollectionFilterOverviewActiveFilterItem">
      <Chip onClick={handleClear} aria-label={ariaLabel}>
        {localizedName}
      </Chip>
      <style jsx>{`
        .CollectionFilterOverviewActiveFilterItem {
          max-width: 100%;
          margin-bottom: ${Theme.get('spacing')}px;
          padding: 0 ${Theme.get('spacing') / 2}px;
        }
      `}</style>
    </div>
  );
};

CollectionFilterOverviewActiveFilterItem.propTypes = {
  option: PropTypes.shape({ filterIdentifier: PropTypes.string, option: PropTypes.string })
    .isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CollectionFilterOverviewActiveFilterItem;
